import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

// Aponta para o controller que criamos anteriormente no Spring Boot
const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/importacaoOrigens/');

export default class ImportacaoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  // Faz o download do template (xlsx)
  // responseType: 'blob' é essencial para baixar arquivos binários
  async baixarModelo(entidade: string) {
    return await this.axios.get(`/modelo/${entidade}`, { responseType: 'blob' });
  }

  // Envia o arquivo para o endpoint específico
  async importar(entidade: string, file: File) {
    const formData = new FormData();
    formData.append('file', file);

    // O Axios detecta FormData e ajusta o Content-Type automaticamente para multipart/form-data
    return await this.axios.post(`/${entidade.toLowerCase()}`, formData);
  }
}